import styled from 'styled-components';

export const InfoContainer = styled.div`
  color: var(--color-dark);
  background: ${({ lightBg }) => (lightBg ? 'var(--color-off-white)' : 'var(--color-cream)')};
  border-top: 1px solid var(--color-grey-light);

  @media screen and (max-width: 768px) {
    padding: 100px 0px 300px 0px;
  }
`;

export const InfoWrapper = styled.div`
  display: grid;
  z-index: 1;
  height: 860px;
  width: 100%;
  max-width: 1100px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 24px;
  justify-content: center;
`;

export const InfoRow = styled.div`
  display: grid;
  grid-auto-columns: minmax(auto, 1fr);
  align-items: center;
  grid-template-areas: ${({ imgStart }) =>
    imgStart ? "'col2 col1'" : "'col1 col2'"};

  @media screen and (max-width: 768px) {
    grid-template-areas: ${({ imgStart }) =>
      imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`};
  }
`;

export const Column1 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col1;
`;

export const Column2 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col2;
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 60px;
`;

export const TopLine = styled.div`
  color: var(--color-gold);
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-bottom: 16px;
  font-family: var(--font-body);
`;

export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 42px;
  line-height: 1.15;
  font-weight: 700;
  font-family: var(--font-heading);
  color: ${({ lightText }) => (lightText ? 'var(--color-cream)' : 'var(--color-dark)')};

  @media screen and (max-width: 480px) {
    font-size: 30px;
  }
`;

export const Subtitle = styled.p`
  max-width: 440px;
  margin-bottom: 35px;
  font-size: 17px;
  line-height: 28px;
  color: ${({ darkText }) => (darkText ? 'var(--color-dark)' : 'var(--color-cream)')};
  font-weight: 400;
`;

export const BtnWrap = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const ImgWrap = styled.div`
  max-width: 555px;
  height: 100%;
`;

export const Img = styled.img`
  width: 100%;
  margin-top: 0;
  margin-right: 0;
  margin-left: 10px;
  padding-right: 0;
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-md);
`;